<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="addgroupuser"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5 class="mx-0 px-2">
              {{ $t("add_users") }}
            </h5>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="assignusers">
              <ComboBox
                :data="sortedusers"
                :isItemChecked="(user) => selectedusers.includes(user.id)"
                @checkClick="(user) => updateUser(user)"
                @doSearch="doSearch"
                :isSelectAll="sortedusers.length === selectedusers.length"
                :selectAll="
                  () =>
                    (selectedusers = allSortedUsers.map(({ id }) => id))
                "
                :deSelectAll="() => (selectedusers = [])"
                :label="$t('users')"
              />
              <div
                class="form-group"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ $t("save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
// import CongratulationsModal from "./CongratulationsModal";
import ComboBox from "../../components/ComboBox.vue";

export default {
  name: "AddGroupUser",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      sortedusers: [],
      allSortedUsers: [],
      selectedusers: [],
      selectedUsersArr: [],
      dropdownShow: false,
      mssg: "",
      Errormssg: "",
      searchQuery: "",

      // congratulationsModal: true,
    };
  },
  mounted() {
    this.getUsers().then(() => {
      let activeusers = this.singlegroup.users.map((user) => user.id);
      this.sortedusers = this.users
        .filter((user) => !activeusers.includes(user.id))
        .map(({ fullname, ...rest }) => ({
          name: fullname,
          fullname,
          ...rest,
        }));
      // let userNames = this.sortedusers.map(({ fullname, ...rest }) => ({
      //   name: fullname,
      //   ...rest,
      // }));
      // this.sortedusers = userNames;
      this.allSortedUsers = this.sortedusers;
      this.isLoading = false;
    });
  },
  components: {
    Loading,
    // CongratulationsModal,
    ComboBox,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["users", "singlegroup"]),
  },
  methods: {
    ...mapActions(["addGroupUsers", "fetchSingleGroup", "getUsers"]),
    onCancel() {
      this.$emit("closeAddGroupUser");
    },
    closeDropdown() {
      if (this.dropdownShow == true) {
        this.dropdownShow = false;
      }
    },
    assignusers() {
      // console.log("Users assigned");
      this.Errormssg = "";
      // let users = document.getElementsByClassName("checkbox");
      // let selectedusers = [];
      // for (let i = 0; i < users.length; i++) {
      //   if (users[i].checked) {
      //     selectedusers.push(
      //       ...this.users.filter((user) => user.id == users[i].value)
      //     );
      //   }
      // }
      const newusers = {
        users: this.selectedusers,
      };
      if (this.selectedusers.length > 0) {
        this.isLoading = true;
        this.addGroupUsers({ users: newusers, id: this.$route.params.id })
          .then((res) => {
            this.isLoading = false;
            this.fetchSingleGroup({ id: this.$route.params.id }).then(() => {
              this.onCancel();
            });
            this.mssg = res.data.payload.message;
            setTimeout(() => {
              this.isLoading = true;
            }, 1000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      } else {
        this.Errormssg = "No user(s) selected";
      }
      // console.log(newusers, "newusers");
    },
    doSearch({ target: { value } }) {
      let activeusers = this.singlegroup.users.map((user) => user.id);
      const filtered = this.users
        .filter(
          (user) =>
            user.fullname.toLowerCase().includes(value.toLowerCase()) &&
            !activeusers.includes(user.id)
        )
        .map(({ fullname, ...rest }) => ({
          name: fullname,
          ...rest,
        }));
      this.sortedusers = filtered;
    },
    updateUser(val) {
      const index = this.selectedusers.indexOf(val.id);
      if (index !== -1) {
        this.selectedusers.splice(index, 1);
      } else this.selectedusers = [...this.selectedusers, val.id];
    },
  },
};
</script>

<style scoped>
.modal-content {
  overflow-y: inherit;
}
.modal-dialog {
  max-width: 500px !important;
}
.dropdown-toggle {
  border: 1px solid;
}
.device-dropdown {
  position: absolute;
  will-change: transform;
  top: 20px;
  left: -45%;
  transform: translate3d(313px, 35px, 0px);
  max-height: 200px;
  width: 15rem;
  overflow-y: auto;
}
.dropdown-button {
  border-radius: 2px;
}
</style>

<i18n>
{
	"en": {
		"add_users": "Add Users",
		"sel_users": "Select Users"
	},
	"fr": {
		"add_users": "Ajouter des utilisateurs",
		"sel_users": "Sélectionnez les utilisateurs"
	},
	"sw": {
		"add_users": "Ongeza Watumiaji",
		"sel_users": "Chagua Watumiaji"
	}
}
</i18n>
